<template>
  <div class="rd-lib">
    <div style="margin-bottom: 10px" class="df both-side">
      <a-space>
        <div>{{ route.query.projectName }}</div>
        <a-select
          allowClear
          v-model:value="requestPayload.projectLifeCycle"
          @change="handleSearch"
          placeholder="项目阶段"
          style="width: 160px"
          :options="projectLifeCycleOptions"
        >
        </a-select>

        <!-- <a-select
          allowClear
          v-model:value="requestPayload.structureName"
          @change="handleSearch"
          placeholder="研发组织"
          style="width: 160px"
          :options="structureOptions"
        >
        </a-select> -->

        <a-select
          allowClear
          v-model:value="requestPayload.fileType"
          @change="handleSearch"
          placeholder="文件类型"
          style="width: 160px"
        >
          <a-select-option value="input">输入文件</a-select-option>
          <a-select-option value="output">输出文件</a-select-option>
        </a-select>

        <a-input
          allowClear
          style="width: 160px"
          placeholder="资料主题"
          @change="handleSearch"
          v-model:value="requestPayload.theme"
        >
        </a-input>
      </a-space>
      <a-button @click="handleUpdateLib(null)">新增</a-button>
    </div>

    <c-table
      :libData="libData"
      @updateTable="updateTable"
      v-if="libData.length > 0"
    ></c-table>

    <data-base-form
      ref="dataBaseFormRef"
      @hadleUpdateTable="hadleUpdateTable"
    ></data-base-form>

    <notice-staff
      ref="noticeStaffRef"
      @handleSelectStaff="handleSelectStaff"
    ></notice-staff>
  </div>
</template>

<script>
import { defineComponent, inject, provide, reactive, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { debounce, Toast, timeStampToTime } from "@/utils/index";
import { getRNDDataLibList, deleteDataLib } from "@/request/view/project";
import {
  projectLifeCycleOptions,
  structureOptions,
} from "@/views/rdmanagement/components/database/options";
import customSelect from "@/views/rdmanagement/components/database/customSelect.vue";
import cTable from "@/views/rdmanagement/components/database/tableLayout.vue";
import dataBaseForm from "@/views/rdmanagement/components/database/form.vue";
import noticeStaff from "@/components/chooseStaff/index.vue";
import websocket from "@/utils/base/socket";
import { showModal } from "@/views/repairprogress/serve/modal";
import { useStore } from "vuex";

export default defineComponent({
  props: { libType: String },
  components: { cTable, customSelect, dataBaseForm, noticeStaff },
  setup(props, context) {
    const user = useStore().state.user.user;
    const route = useRoute();
    const { projectId, projectLifeCycle } = useRoute().query;

    provide('dataBaseLibtype', props.libType);

    const noticeStaffRef = ref();
    const requestPayload = reactive({
      theme: null,
      fileType: null,
      structureName: null,
      projectLifeCycle: null,
      dataLibType: null,
      projectLifeCycleId: null,
    });
    const libData = ref([]);
    const getListData = () => {
      getRNDDataLibList(requestPayload)
        .then((res) => {
          libData.value.length = 0;
          if (res.data === null) return;
          Object.keys(res.data).forEach((key) => {
            const { output, input } = res.data[key];
            libData.value.push({
              theme: key,
              output: output || {},
              input: input || {},
            });
          });
        })
        .catch((err) => {});
    };

    const dataBaseFormRef = ref();

    const handleUpdateLib = (record, libName, isIteration) => {
      let title = record === null ? "新增资料" : "编辑资料";
      let type = record === null ? "insert" : "update";

      if (!!isIteration) {
        title = "迭代资料";
        type = 'iteration'
      }
      dataBaseFormRef.value.showmodal({
        title,
        type,
        data: record,
        libName,
      });
    };

    const handleDeleteFile = (record) => {};

    const updateTable = () => {
      getListData();
    };

    const handleSearch = debounce(() => {
      getListData();
    }, 200);

    const hadleUpdateTable = () => {
      getListData();
    };

    const activeKey = inject("activeKey");
    const dataBaseKey = inject("dataBaseKey");

    provide("actionOptions", {
      handleUpdateLib,
      handleDeleteFile,
    });

    const handleSelectStaff = (staffId, staffName, staffUserName) => {
      const nickName = user.nickName;
      const localTime = timeStampToTime("", "minutes");
      const { fileName, id } = cacheRecord;

      const query = Object.assign(
        {
          id,
          activeKey: "资料库",
          type: "link",
          dataLibType: requestPayload.dataLibType,
        },
        route.query
      );

      websocket.Send({
        content: `${nickName}在${localTime}推送${fileName}`,
        query: JSON.stringify(query),
        route: "/rdprojectlayout",
        toUserId: staffId,
        type: 0,
        userId: user.id,
      });
    };

    const setRequestPayloadData = () => {
      requestPayload.theme = null;
      requestPayload.fileType = null;
      requestPayload.structureName =
        user.secondaryDepartment || user.firstLevelDepartment;
      requestPayload.projectLifeCycle = route.query.projectLifeCycle;
      requestPayload.dataLibType = props.libType;
      requestPayload.projectLifeCycleId = route.query.projectId;
    };

    watch(
      () => dataBaseKey,
      (val) => {
        if (val.value === props.libType) {
          getListData();
        }
      },
      {
        deep: true,
      }
    );

    watch(
      () => activeKey,
      (val) => {
        if (val.value === '资料库') {
          getListData();
        }
      },
      {
        deep: true,
      }
    );

    watch(
      () => route,
      (val) => {
        if (val.path === "/rdprojectlayout") {
          setRequestPayloadData();
          getListData();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      noticeStaffRef,
      updateTable,
      route,
      handleSelectStaff,
      requestPayload,
      projectLifeCycleOptions,
      structureOptions,
      handleSearch,
      libData,
      hadleUpdateTable,
      handleUpdateLib,
      dataBaseFormRef,
    };
  },
});
</script>

<style lang="less" scoped>
.rd-lib {
}
</style>
